import Heading from "@tiptap/extension-heading"
import slugify from "slugify"
import { getHeadingClasses } from "./util"

// Helper function to determine classes based on level (mirrors your renderer)

export const HeadingWithId = Heading.extend({
  // You might want to configure default HTML attributes if needed
  // addOptions() {
  //   return {
  //     ...this.parent?.(),
  //     HTMLAttributes: {
  //        // Default classes can go here, but renderHTML is more specific
  //     },
  //   }
  // },

  renderHTML({ node, HTMLAttributes }) {
    const hasLevel = this.options.levels.includes(node.attrs.level)
    const level = hasLevel ? node.attrs.level : this.options.levels[0]

    // 1. Get the specific classes for this heading level
    const levelClasses = getHeadingClasses(level)

    // 2. Combine with existing classes from options and passed attributes
    //    Ensure proper spacing and avoid duplicates if possible (though browsers handle duplicates fine)
    const existingClasses = [
      this.options.HTMLAttributes?.class, // Class from extension config
      HTMLAttributes?.class, // Class passed down dynamically
    ]
      .filter(Boolean)
      .join(" ") // Filter out undefined/null/empty and join

    // Concatenate all classes, removing extra spaces
    const finalClasses = [existingClasses, levelClasses]
      .filter(Boolean) // Remove empty strings
      .join(" ")
      .trim() // Trim leading/trailing spaces

    // 3. Generate the ID
    const id = `h-${slugify(node.textContent, { lower: true, strict: true })}`

    // 4. Construct the final attributes for the heading tag
    const headingAttributes = {
      // Start with defaults from options
      ...this.options.HTMLAttributes,
      // Override/merge with dynamically passed attributes
      ...HTMLAttributes,
      // Add the generated ID
      id,
      // Set the combined classes, only if there are any
      ...(finalClasses ? { class: finalClasses } : {}),
    }
    // Remove the original 'class' properties from the spread objects if they exist
    // to avoid potential confusion, though the final 'class' property assignment takes precedence.
    // delete headingAttributes.class; // This line isn't strictly needed due to the spread order

    // 5. Return the render array structure
    return [
      `h${level}`, // e.g., "h1", "h2"
      headingAttributes, // The merged attributes including id and classes
      0, // Placeholder for the heading content
    ]
  },
})

export default HeadingWithId
